module.exports = __webpack_public_path__ + "img/20251126.80d391e5.png";